<template>
    <div class="home">
        <site-top-slider></site-top-slider>
        <site-separator separator="blue"></site-separator>
        <site-advantages></site-advantages>
        <div class="sectionBar"></div>
        <site-why-us></site-why-us>
        <site-partners></site-partners>
    </div>
</template>

<script>
import SiteSeparator from '../components/site/SiteSeparator'
import SitePartners from '../components/site/SitePartners'
import SiteWhyUs from '../components/site/SiteWhyUs'
import SiteAdvantages from '../components/site/SiteAdvantages'
import SiteTopSlider from '../components/site/SiteTopSlider'
import Animate from '../assets/js/animation'

export default {
  name: 'home',
  components: {
    SiteTopSlider,
    SiteAdvantages,
    SiteWhyUs,
    SitePartners,
    SiteSeparator
  },
  mounted () {
    Animate()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Home.vue